import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { AboutSection } from '../components/AboutSection';
import { PhasesSection } from '../components/PhasesSection';
import { AgendaSection } from '../components/AgendaSection';
import { RouteMapSection } from '../components/RouteMapSection';
import { VenueMapSection } from '../components/VenueMapSection';
import { PetWallSection } from '../components/PetWallSection';
import { TicketsSection } from '../components/TicketsSection';
import { SponsorsSection } from '../components/SponsorsSection';
import { ActivitiesSection } from '../components/ActivitiesSection';
import { LocationSection } from '../components/LocationSection';
import { CauseSection } from '../components/CauseSection';
import { ContactSection } from '../components/ContactSection';
import { SponsorsBannerSection } from '../components/SponsorsBannerSection';
export function HomePage() {
  return <>
      <HeroSection data-id="element-2484" />
      <ActivitiesSection data-id="element-2485" />
      <AboutSection data-id="element-2486" />
      <TicketsSection data-id="element-2487" />
      <CauseSection data-id="element-2488" />
      <SponsorsBannerSection data-id="element-2489" />
      <SponsorsSection data-id="element-2490" />
      <AgendaSection data-id="element-2491" />
      <RouteMapSection data-id="element-2492" />
      <VenueMapSection data-id="element-2493" />
      <PetWallSection data-id="element-2494" />
      <LocationSection data-id="element-2495" />
      <PhasesSection data-id="element-2496" />
      <ContactSection data-id="element-2497" />
    </>;
}